exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".bookNav.is-centered{justify-content:center}.bookNext{max-width:1000px;margin-right:auto;margin-left:auto}", ""]);
